function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useTheme } from 'styled-components';
var BirminghamMidshiresIcon = function BirminghamMidshiresIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C18.0752 1 23 5.92479 23 12C23 18.0752 18.0752 23 12 23C5.92479 23 1 18.0752 1 12C1 5.92479 5.92479 1 12 1ZM12 3C7.02936 3 3 7.02936 3 12C3 16.9706 7.02936 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02936 16.9706 3 12 3ZM13.082 6V13.0809L8.70711 17.4557L7.29289 16.0415L11.081 12.252L11.082 6H13.082Z",
    fill: "currentColor"
  }));
};
BirminghamMidshiresIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4652 13.0739H10.9768V6.25679C10.9768 5.69648 11.4419 5.22955 12.0001 5.22955C12.5582 5.22955 13.0233 5.69648 13.0233 6.25679V11.0194H16.4652C17.0233 11.0194 17.4884 11.4864 17.4884 12.0467C17.4884 12.607 17.0233 13.0739 16.4652 13.0739ZM12 0C5.39535 0 0 5.41634 0 12.0467C0 18.677 5.39535 24 12 24C18.6047 24 24 18.677 24 12.0467C24 5.41634 18.6047 0 12 0ZM12.0001 21.2918C6.88379 21.2918 2.79077 17.1829 2.79077 12.0467C2.79077 6.91052 6.88379 2.80157 12.0001 2.80157C17.1164 2.80157 21.2094 6.91052 21.2094 12.0467C21.2094 17.1829 17.1164 21.2918 12.0001 21.2918Z",
    fill: "currentColor"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C18.0752 1 23 5.92479 23 12C23 18.0752 18.0752 23 12 23C5.92479 23 1 18.0752 1 12C1 5.92479 5.92479 1 12 1ZM12 3C7.02936 3 3 7.02936 3 12C3 16.9706 7.02936 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02936 16.9706 3 12 3ZM13.082 6V13.0809L8.70711 17.4557L7.29289 16.0415L11.081 12.252L11.082 6H13.082Z",
    fill: "currentColor"
  }));
};
HalifaxIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var LloydsReimaginedIcon = function LloydsReimaginedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 1C5.92 1 1 5.92 1 12C1 18.08 5.92 23 12 23C18.08 23 23 18.08 23 12C23 5.92 18.08 1 12 1ZM12 21.7C6.65 21.7 2.3 17.35 2.3 12C2.3 6.65 6.65 2.29999 12 2.29999C17.35 2.29999 21.7 6.65 21.7 12C21.7 17.35 17.35 21.7 12 21.7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.61 14.53L16.81 17.73L17.73 16.81L14.53 13.61C14.29 13.98 13.98 14.29 13.61 14.53Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.65 10.65V3.83002H11.35V10.65C10.85 10.89 10.5 11.4 10.5 12C10.5 12.83 11.17 13.5 12 13.5C12.83 13.5 13.5 12.83 13.5 12C13.5 11.41 13.15 10.9 12.65 10.65Z",
    fill: "currentColor"
  }));
};
LloydsReimaginedIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Lloyds2023Icon = function Lloyds2023Icon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4652 13.0739H10.9768V6.25679C10.9768 5.69648 11.4419 5.22955 12.0001 5.22955C12.5582 5.22955 13.0233 5.69648 13.0233 6.25679V11.0194H16.4652C17.0233 11.0194 17.4884 11.4864 17.4884 12.0467C17.4884 12.607 17.0233 13.0739 16.4652 13.0739ZM12 0C5.39535 0 0 5.41634 0 12.0467C0 18.677 5.39535 24 12 24C18.6047 24 24 18.677 24 12.0467C24 5.41634 18.6047 0 12 0ZM12.0001 21.2918C6.88379 21.2918 2.79077 17.1829 2.79077 12.0467C2.79077 6.91052 6.88379 2.80157 12.0001 2.80157C17.1164 2.80157 21.2094 6.91052 21.2094 12.0467C21.2094 17.1829 17.1164 21.2918 12.0001 21.2918Z",
    fill: "currentColor"
  }));
};
Lloyds2023Icon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
import { LLOYDS, BIRMINGHAM_MIDSHIRES, BOS, HALIFAX, LLOYDS2023 } from "../../constants";
export default function Clock(_ref) {
  var _theme$assets, _theme$assets$icons;
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = useTheme();
  var svg;
  if ((_theme$assets = theme.assets) !== null && _theme$assets !== void 0 && (_theme$assets$icons = _theme$assets.icons) !== null && _theme$assets$icons !== void 0 && _theme$assets$icons.clock) {
    svg = theme.assets.icons.clock;
  } else {
    switch (brand) {
      case BIRMINGHAM_MIDSHIRES:
        svg = BirminghamMidshiresIcon;
        break;
      case BOS:
        svg = BosIcon;
        break;
      case HALIFAX:
        svg = HalifaxIcon;
        break;
      case LLOYDS:
        svg = LloydsReimaginedIcon;
        break;
      case LLOYDS2023:
        svg = Lloyds2023Icon;
        break;
      default:
        console.warn("Icon \"Clock\" is not available for brand ".concat(brand));
        svg = function svg() {
          return null;
        };
    }
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}